import { faro } from '@grafana/faro-web-sdk';
import { isClientInitialized } from './grafanaFaroUtil';

type Logger = {
  pushEvent: typeof faro.api.pushEvent;
  pushError: typeof faro.api.pushError;
  pushLog: typeof faro.api.pushLog;
  pushMeasurement: typeof faro.api.pushMeasurement;
  setView: typeof faro.api.setView;
};

function localLogger(loggerName: string) {
  return (...args: unknown[]) => {
    if (process.env.NODE_ENV !== 'test') {
      // eslint-disable-next-line no-console
      console.log(`[RNT Logger]:${loggerName}`, ...args);
    }
  };
}

const defaultLogger: Logger = {
  pushEvent: localLogger('pushEvent'),
  pushError: localLogger('pushError'),
  pushLog: localLogger('pushLog'),
  pushMeasurement: localLogger('pushMeasurement'),
  setView: localLogger('setView')
};

export function getLogger() {
  if (!isClientInitialized(faro)) {
    return defaultLogger;
  }

  const logger: Logger = {
    pushEvent: faro.api.pushEvent,
    pushError: faro.api.pushError,
    pushLog: faro.api.pushLog,
    pushMeasurement: faro.api.pushMeasurement,
    setView: faro.api.setView
  };

  return logger;
}

/**
 * React hooks to be used in react components
 */

export function useLogger() {
  return getLogger();
}
